import { Component } from '@angular/core';

@Component({
  templateUrl: './select-params.component.html'
})
export class SelectParamsComponent { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/select-params/select-params.component.ts